export const calculateSubDisciplineTotal = (selected: any[], type: 1 | 2, dep: any) => {
  const selectedCodes = Object.entries(selected)
    .filter(([code, isSelected]) => isSelected)
    .map(([code]) => code);
  if (selectedCodes.length === 0) return 0;
  const targetResourceTypeCodes = dep.resourceType
    .filter((item) => selectedCodes.includes(item.disciplineCode))
    .map((item) => item.resourceTypeCode);
  if (targetResourceTypeCodes.length === 0) return 0;
  const matchedItems = dep.resourceLoadingConstraint.filter((item) => targetResourceTypeCodes.includes(item.resourceTypeCode));
  if (type === 1) {
    return matchedItems.length;
  } else if (type === 2) {
    return Math.max(...matchedItems.map((a) => a.roleMpUpper || 0));
  }
  return 0;
};

export const calculateDisciplineTotal = (selected: any[], type: 1 | 2, dep: any) => {
  const selectedCodes = Object.entries(selected)
    .filter(([code, isSelected]) => isSelected)
    .map(([code]) => code);
  if (selectedCodes.length === 0) return 0;
  const targetResourceTypeCodes = dep.resourceType
    .filter((item) => selectedCodes.includes(item.disciplineCode))
    .map((item) => item.resourceTypeCode);
  if (targetResourceTypeCodes.length === 0) return 0;
  const matchedItems = dep.resourceLoadingConstraint.filter((item) => targetResourceTypeCodes.includes(item.parentResourceTypeCode));
  if (type === 1) {
    return matchedItems.length;
  } else if (type === 2) {
    return Math.max(...matchedItems.map((a) => a.disciplineMpUpper || 0));
  }
  return 0;
};

export const calculateAreaTotal = (selected: any[], type: 1 | 2, dep: any) => {
  const selectedAreaNames = Object.entries(selected)
    .filter(([areaName, isSelected]) => isSelected)
    .map(([areaName]) => areaName);

  if (selectedAreaNames.length === 0) return 0;

  const matchedAreas = dep.area.filter((item) => selectedAreaNames.includes(item.area));

  if (type === 1) {
    return matchedAreas.length;
  } else if (type === 2) {
    return Math.max(...matchedAreas.map((a) => a.areaMpUpper || 0));
  }

  return 0;
};
